<template>
	<div>
		<div class="shadow rounded p-10">
			<div class="row mt-4 ">
				<div class="col-12 col-md-8 Aligner-Header">
					<span class="h3title">Sales Analysis</span>
				</div>
				<div class="col-12 row ml-4">
					<div class="col-md-4 col-12 row" style="padding-top:6px;">
						<div class="col" style="padding-right:0">
							<button 
								style="border-radius : 6px 0px 0px 6px"
								type="button" 
								class="w-100 btn" 
								:class="(timeWindow == 'Bulanan') ? 'btn-primary' : 'btn-outline-primary'" 
								@click="timeWindow = 'Bulanan'"
							>
								Bulanan
							</button>
						</div>
						<div class="col" style="padding-left:0">
							<button 
								style="border-radius : 0px 6px 6px 0px"
								type="button" 
								class="w-100 btn" 
								:class="(timeWindow == 'Mingguan') ? 'btn-primary' : 'btn-outline-primary'" 
								@click="timeWindow = 'Mingguan'"
							>
								Mingguan
							</button>
						</div>
					</div>
					<div class="col-md-1 col-12"/>
					<div class="col-12 offset-md-1 col-md-7 row">
						<div class="col-12 col-md-3 highlightFilter">
							<Multiselect
								class="mt-1 "
								:options="semesterOption"
								:searchable="true"
								:close-on-select="true"
								:allow-empty="false"
								v-model="filter.salesAnalysis.semester"
								placeholder="Choose semester"
								:selectLabel="'Press To Select'"
							/>
						</div>
						<div class="col-12 col-md-3 highlightFilter">
							<Multiselect
								class="mt-1 "
								:options="options.karesidenan.map(type => type.code)"
								:custom-label="opt => options.karesidenan.find(x => x.code == opt).name"
								:searchable="true"
								:close-on-select="true"
								:allow-empty="true"
								v-model="filter.salesAnalysis.karesidenan"
								placeholder="All Karesidenan"
								:selectLabel="'Press To Select'"
							/>
						</div>
						<div class="col-12 col-md-3 highlightFilter">
							<Multiselect
								class="mt-1 "
								:options="options.city.map(type => type.code)"
								:custom-label="opt => options.city.find(x => x.code == opt).name"
								:searchable="true"
								:close-on-select="true"
								:allow-empty="true"
								v-model="filter.salesAnalysis.city"
								placeholder="All City"
								:selectLabel="'Press To Select'"
							/>
						</div>
						<div class="col-12 col-md-3 highlightFilter">
							<Multiselect
								class="mt-1 "
								:options="options.dealer.map(type => type.code)"
								:custom-label="opt => options.dealer.find(x => x.code == opt).name"
								:searchable="true"
								:close-on-select="true"
								:allow-empty="true"
								v-model="filter.salesAnalysis.dealer"
								placeholder="All Dealer"
								:selectLabel="'Press To Select'"
							/>
						</div>
						<div class="col-md-6"></div>
						<div class="col-12 col-md-3 highlightFilter">
							<Multiselect
								class="mt-2 "
								:options="avgOption"
								:searchable="true"
								:close-on-select="true"
								:allow-empty="false"
								v-model="avgDailySales"
								placeholder="Choose Chart Type"
								:selectLabel="'Press To Select'"
							/>
						</div>
						<div class="col-12 col-md-3 highlightFilter">
							<button
								type="button"
								class="mt-2 btn btn-warning w-100"
								style="height:90%"
								@click="exportExcel('Sales Analysis')"
							>Download XLS <i class="fas fa-download"></i></button>
						</div>
					</div>
				</div>
			</div>

			<!-- Sales Analysis Chart Start -->
			<div class="pr-2 mt-2">
				<sales-analysis-chart
					:timeWindow="timeWindow"
					:avgDailySales="avgDailySales"
					:data="data.salesAnalysis"
					:dataWeekly="data.salesAnalysisWeekly"
					v-if="data.salesAnalysis && data.salesAnalysisWeekly"
				></sales-analysis-chart>
				<div v-else class="text-center mt-3"><h4>Loading......</h4></div>
			</div>
		</div>
		<!-- Sales Analysis Chart End -->
	</div>
</template>

<script>
	import Multiselect from 'vue-multiselect'
	import salesAnalysisChart from './../children/sales/salesAnalysisChart'
	const XLSX = require('xlsx')
	import moment from 'moment'
	import listUrl from './../listUrl.js'

export default {
	props: ['period', 'mobile', 'filter' ,'data'],
	components: {
		Multiselect,
		salesAnalysisChart,
	},
	data () {
		return {
			semesterOption : [],
			avgOption : ['AVG Daily Sales', 'Total Sales'],
			avgDailySales : 'Total Sales',//Avg Daily Sales - 'AVG Daily Sales' or 'Total Sales'
			options : this.$store.getters.getFilterOptions,
			timeWindow : 'Bulanan',//'Bulanan' or 'Mingguan'
		}
	},
	mounted () {
		this.generateSemesterOptions();
		this.$emit('search')
	},
	watch : {
		'filter.salesAnalysis.karesidenan' : {
			handler(){
				this.filter.salesAnalysis.city = ''
				this.filter.salesAnalysis.dealer = ''

				this.options.city = this.$store.getters.getCityBySingleId(this.filter.salesAnalysis.karesidenan);
				this.options.dealer = this.$store.getters.getDealerBySingleId(this.filter.salesAnalysis.karesidenan, this.filter.salesAnalysis.city);
			}
		},	
		'filter.salesAnalysis.city' : {
			handler(){
				this.filter.salesAnalysis.dealer = ''

				this.options.dealer = this.$store.getters.getDealerBySingleId(this.filter.salesAnalysis.karesidenan, this.filter.salesAnalysis.city);
			}
		},
		"filter.salesAnalysis" : {
		  deep: true,
		  handler: function () {
		    let url = listUrl.stringUrl.salesAnalysis.salesAnalysis
			let params = listUrl.param.salesAnalysis.salesAnalysis

			this.$emit('loadAPI' , url , params )
		  }
		}
	},
	methods : {
		generateSemesterOptions(){
			var semesters = [];
			let yearNow = new moment().year()

			for(var i = yearNow ; i >= 2018 ; i-- ) {
				for(var j = 2 ; j >= 1 ; j--) {
					semesters.push(`S${j} - ${i}`)
				}
			}
			
			console.log(new moment().month())
			this.filter.salesAnalysis.semester = new moment().month() > 5 ? `S2 - ${new moment().year()}` : `S1 - ${new moment().year()}`
			this.semesterOption = semesters;
		},
		exportExcel (filename) {
			let wb = XLSX.utils.book_new()
			var ws = XLSX.utils.json_to_sheet(this.timeWindow == 'Bulanan' ? this.data.salesAnalysis : this.data.salesAnalysisWeekly, {raw:true});
			XLSX.utils.book_append_sheet(wb, ws, 'Data')
			XLSX.writeFile(wb, `${filename} ${this.timeWindow}.xls`)
		}
	}
}

function s2ab(s) {
	var buf = new ArrayBuffer(s.length);
	var view = new Uint8Array(buf);
	for (var i=0; i!=s.length; ++i) view[i] = s.charCodeAt(i) & 0xFF;
	return buf;
}
</script>

<style scoped>
	.h3title{
		margin: 0 0 8px 0;
		font-weight:600;
		line-height:1.2;
		font-size: x-large;
		display:block;
		margin-inline-start: 0;
		margin-inline-end: 0;
		color:#707070;
	}

	.btn-primary {
		background-color: #FF9700;
		border-color: #FF9700;
	}

	.btn-outline-primary {
		border-color: #FF9700;
		color: #FF9700;
	}

	.btn-outline-primary:hover {
		background-color: #FF9700;
		color: white;
	}

	.btn-outline-primary:focus {
		background-color:#FF9700;
	}
</style>